<template>
  <div class="pointer-events-none absolute inset-x-0 bottom-0 items-center p-2">
    <div class="absolute-0 flex center gap-2">
      <div v-for="(_, i) in totalVideos" :key="i">
        <base-button
          :aria-label="replaceAll($t.goToSlide, { slide: `${i + 1}` })"
          class="pointer-events-auto relative block overflow-hidden rounded-full bg-brand-2 duration "
          :style="{ width: i === activeIndex ? '2.5rem' : '0.375rem', height: '0.375rem' }"
          @click="$emit('navigate', i)"
        >
          <span
            v-if="i === activeIndex"
            class="absolute left-0 top-0 h-full bg-brand-3 ease-linear duration o:bg-grey-40"
            :style="{ width: `${progress * 100}%` }"
          />
        </base-button>
      </div>
    </div>
    <base-button
      :aria-label="paused ? $t.videoPlay : $t.videoPause"
      class="pointer-events-auto ml-a block b b-white rounded-full bg-white bg-op-70 p-1 c-brand-1 duration hover:bg-op-100 "
      @click="$emit('toggle')"
    >
      <vf-icon :name="paused ? 'play' : 'pause'" :size />
    </base-button>
  </div>
</template>

<script lang="ts" setup>
import type { Responsive } from '#types/common'
import type { IconSizes } from '#types/sizes'

export interface Props {
  activeIndex?: number
  progress?: number
  totalVideos?: number
  paused?: boolean
  size?: IconSizes | Partial<Responsive<IconSizes>>
}

export interface Emits {
  toggle: []
  navigate: [index: number]
}

const { activeIndex = 0, progress = 0, paused = false, size, totalVideos = 1 } = defineProps<Props>()
defineEmits<Emits>()
</script>
